import Grid from '../Grid'
import { LeksikonCategory } from '../LeksikonCategory'
import { LeksikonDirectoryProps } from './props'

const LeksikonDirectory = ({ content }: LeksikonDirectoryProps) => {
    const nodeContent = content.map(({ buttons, title }, key) => (
        <LeksikonCategory buttons={buttons} key={key} title={title} />
    ))

    return <Grid gap={16}>{nodeContent}</Grid>
}

export default LeksikonDirectory
